import LS from './LocalStorageManager';
import { IPhone } from '../models';

export enum SKILLS {
    RECEPTION = "reception",
    BOOKING = "booking",
    VOICEMAIL = "voicemail",
    DSR = "dsr",
}

export interface IWorker {
    isReceptionist(): boolean;
    isDsr(): boolean;
}

export class Worker implements IWorker {

    _worker: any

    constructor(worker: any) {
        this._worker = worker;
    }

    isReceptionist(): boolean {
        const skills = this._worker.skills || [];

        if (skills.indexOf(SKILLS.RECEPTION) >= 0) {
            return true;
        }

        return false;
    }

    isDsr(): boolean {
        const skills = this._worker.skills || [];

        if (skills.indexOf(SKILLS.DSR) >= 0) {
            return true;
        }

        return false;
    }
}
